<!-- tags 公共标签 -->
<template>
  <div class="tag_box" :class="{ 'checkfield': isswitch }" @click.stop="toggle">
    <slot></slot>
    <!-- <div class="tag_close_icon" v-if="!isswitch"><a-icon type="close-circle"/></div> -->
  </div>
</template>

<script>
export default {
  props: ['code', 'closeAll'],

  watch: {
    closeAll(val) {
      this.isswitch = false;
    }
  },

  data() {
    return {
      isswitch: false
    };
  },
  methods: {
    toggle() {
      this.isswitch = !this.isswitch;
      this.$emit('change', { flag: this.isswitch, code: this.code });
    }
  }
};
</script>
